// External deps explicitly defined to ensure order of processing
import * as Sentry from "@sentry/browser"
import { ExtraErrorData } from "@sentry/integrations"
import { FP } from "../deps"

import { environment } from "../environment"

Sentry.init({
  dsn: "https://c07ba603ad0d44828174037416218736@o1053471.ingest.sentry.io/6037994",
  tracesSampleRate: 1.0,
  environment,

  integrations: [
    new ExtraErrorData({
      depth: 5,
    }),
  ],

  ignoreErrors: [
    // Ignore sentry issue SELLALONG-9D: https://sentry.io/share/issue/fd50f6f31e914a728af414755ea41a20/
    // error caused by adscale app 404 xhr errors on sirplus
    "Non-Error promise rejection captured with keys: status, statusText",
  ],

  allowUrls: [/^https?:\/\/([^\.]+\.)?sellalong\.io/],

  denyUrls: [
    // below are from: https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
})

export function setUser(id: string) {
  Sentry.setUser({
    id,
  })
}

export function recordError(error: any) {
  Sentry.captureException(error)
}

export const recordTaskEitherError: <A>(
  a: FP.taskEither.TaskEither<Error, A>
) => FP.task.Task<A | void> = FP.task.map(FP.either.getOrElseW(recordError))
